<template>
  <v-form
    ref="form"
    v-model="valid"
  >
    <v-text-field
      v-model="category.name"
      label="Name"
      maxlength="100"
      outlined
      :rules="[$rules.required]"
    />
    <v-text-field
      v-model="category.namePlural"
      label="Plural Name"
      :rules="[$rules.required]"
      outlined
      maxlength="100"
    />
    <v-text-field
      v-model="category.urlSegment"
      label="Url Segment"
      maxlength="100"
      outlined
      :rules="[$rules.required]"
    />
    <v-select
      v-if="category.type"
      v-model="category.type.id"
      :items="category_types"
      item-text="name"
      item-value="id"
      label="Type"
      :rules="[$rules.required]"
      outlined
    />
    <v-select
      v-if="category.parentCategory"
      v-model="category.parentCategory.id"
      :items="parent_categories"
      item-text="name"
      item-value="id"
      label="Parent Category"
      outlined
    />
    <v-textarea
      v-model="category.designNotes"
      label="Design Notes"
      hide-details
      outlined
    />
  </v-form>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'AddCategory',

  data() {
    return {
      category: {},
      valid: false,
      saving: false
    };
  },
  computed: {
    ...mapGetters({
      category_types: 'lookup/category_types',
      parent_categories: 'lookup/parent_categories'
    })
  },
  mounted() {
    this.category = { type: {}, parentCategory: {} };
  },
  methods: {
    save() {
      if (!this.$refs.form.validate()) return;

      this.saving = true;
      this.$store
        .dispatch('categories/create', this.category)
        .then(() => {
          this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.CATALOG_ADD_HIDE);
          this.$root.$snackbarSuccess('Category created');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
